import { Injectable } from '@angular/core';

import { CustomWindow, WindowReferenceService } from '../window-reference/window-reference.service';

// See: https://stackoverflow.com/questions/34177221/angular2-how-to-inject-window-into-an-angular2-service

@Injectable()
export class WindowService {
    constructor(private windowReferenceService: WindowReferenceService) {
    }

    get localStorage(): Storage {
        return this.window.localStorage;
    }

    get sessionStorage(): Storage {
        return this.window.sessionStorage;
    }

    // noinspection JSMethodCanBeStatic
    get window(): CustomWindow {
        return this.windowReferenceService.window;
    }

    // noinspection JSMethodCanBeStatic
    scrollToTop(): void {
        this.window.scrollTo(0, 0);
    }
}
